import React, {FC} from 'react';

import {
  InboxesSearchDropdownSuggestion,
  SuggestionSelectHandler,
} from '../../../../../../srcCommon/inboxes/search/searchSuggestionsHelpers';
import {SearchSuggestionsDropdownSection} from './searchSuggestionsDropdownSection';
import {SearchSuggestionsDropdownSuggestion} from './searchSuggestionsDropdownSuggestion';

/*
 * Props.
 */

interface SearchSuggestionsDropdownSuggestionsProps {
  suggestions: ReadonlyArray<InboxesSearchDropdownSuggestion>;
  onSuggestionSelect: SuggestionSelectHandler;
}

/*
 * Component.
 */

export const SearchSuggestionsDropdownSuggestions: FC<SearchSuggestionsDropdownSuggestionsProps> = (
  props,
) => {
  const {suggestions, onSuggestionSelect} = props;

  if (suggestions.length === 0) {
    return null;
  }

  return (
    <SearchSuggestionsDropdownSection>
      {suggestions.map((suggestion) => (
        <SearchSuggestionsDropdownSuggestion
          key={suggestion.key ?? suggestion.value}
          suggestion={suggestion}
          onSuggestionSelect={onSuggestionSelect}
        />
      ))}
    </SearchSuggestionsDropdownSection>
  );
};
